import AppointmentCheckCircleSvg from '@assets/images/svg/appointment-check-circle.svg';
import React from 'react';
import { View } from 'react-native';

export interface AppointmentCheckCircleIconProps {
    size?: number;
    color?: string;
}

export function AppointmentCheckCircleIcon({ size = 48, color = '#333333' }: Readonly<AppointmentCheckCircleIconProps>) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <AppointmentCheckCircleSvg width={size} height={size} color={color} />
        </View>
    );
}

export default AppointmentCheckCircleIcon;
